import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Admin axios (uses admin token)
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dnj_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("dnj_admin_token");
      localStorage.removeItem("dnj_admin_user");
    }
    return Promise.reject(err);
  }
);

// User axios (uses customer token)
export const userApi = axios.create({ baseURL: API });
userApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("dnj_user_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
userApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("dnj_user_token");
    }
    return Promise.reject(err);
  }
);
